// extracted by mini-css-extract-plugin
export default {"root":"MzPkof","previous":"PZlnoZ","next":"K3x9yL","page":"mbVZQJ","label":"YT9ldc","visuallyHidden":"INxMbz"};